<img
  ngSrc="images/logo.png"
  [width]="size"
  [height]="size"
  alt="{{appname}} Logo"
/>
